import React, { Fragment } from "react"

import InsightAreaListItem from "../../../insight-areas/insight-area-list/InsightAreaListItem"
import InsightAreaListItemShadow from "../../../insight-areas/insight-area-list/InsightAreaListItemShadow"
import expandableItem from "../../../common/ExpandableItem"
import WidgetHeaderButton from "../../../common/WidgetHeaderButton"
import SearchBar from "../../../common/SearchBar"

const ExpandableInsightAreaListItem = expandableItem(
    ({ toggleExpansion, ...topic }) => (
        <InsightAreaListItem
            onClick={() => toggleExpansion}
            toggleExpansion={toggleExpansion}
            {...topic}
        />
    )
)

const ClusterEditItemTopics = ({
    topics,
    concepts,
    onValueChange,
    onSearch,
    onSelect,
    searchTerm,
    isFetchingSearch,
    searchResults,
    onApply
}) => {
    const lowercaseName = concepts ? "concepts" : "topics"
    const onTopicChange = onValueChange(lowercaseName)
    return (
        <div className="widget">
            <h3 className="widget-header">
                <span className={`icon icon-${lowercaseName}`} />
                {concepts ? "Concepts (Machine-detected topics)" : "Topics"}
                {searchTerm && (
                    <div className="pull-right">
                        <WidgetHeaderButton
                            onClick={() => onApply(lowercaseName)}
                        >
                            Apply
                        </WidgetHeaderButton>
                    </div>
                )}
            </h3>
            <p>
                {concepts ? "Concepts" : "Topics"} are{" "}
                <strong>automatically</strong> assigned based on the clustered
                articles.
            </p>
            <div className="search-bar-container">
                <SearchBar
                    searchTerm={searchTerm}
                    name={lowercaseName}
                    placeholder={`search to add ${lowercaseName}`}
                    onSearch={onSearch}
                />
            </div>
            <div className="widget-content list-group items-list cluster-related-items-list">
                {isFetchingSearch ? (
                    [0, 1, 2].map(index => (
                        <InsightAreaListItemShadow key={index} />
                    ))
                ) : (
                    <Fragment>
                        {searchTerm
                            ? searchResults.map(topic => (
                                  <InsightAreaListItem
                                      key={topic.id}
                                      {...topic}
                                      showCheckbox={true}
                                      onClick={() => () =>
                                          onSelect(lowercaseName, topic)}
                                      isChecked={topic.isAdded}
                                  />
                              ))
                            : (concepts || topics || []).map(topic => (
                                  <ExpandableInsightAreaListItem
                                      key={topic.id}
                                      {...topic}
                                      onRemoveClick={topicToRemove => event => {
                                          event.preventDefault()
                                          event.stopPropagation()
                                          onTopicChange(
                                              (concepts || topics || []).filter(
                                                  ({ id }) =>
                                                      id !== topicToRemove
                                              )
                                          )
                                      }}
                                  />
                              ))}
                        {((searchTerm &&
                            !isFetchingSearch &&
                            (!searchResults || !searchResults.length)) ||
                            ((!topics || !topics.length) &&
                                (!concepts || !concepts.length))) && (
                            <p>No {lowercaseName} found.</p>
                        )}
                    </Fragment>
                )}
            </div>
        </div>
    )
}

export default ClusterEditItemTopics
